/* 运行在口袋故事app时可以使用的helper函数 */
export function getCaller() {
  let defaultCaller = '1002'
  let ua = navigator.userAgent.toLocaleLowerCase()
  let reg = /\(\/ilisten_(.*)\)/i
  let match = ua.match(reg)
  if (!match) return defaultCaller
  let info = match[1].split('_')
  let caller = info[1]
  if (!caller) return defaultCaller
  return caller
}

export function getAppVersion() {
  let defaultVersion = '1.0.0'
  let ua = navigator.userAgent.toLocaleLowerCase()
  let reg = /\(\/ilisten_(.*)\)/i
  let match = ua.match(reg)
  if (!match) return defaultVersion
  let info = match[1].split('_')
  let prdVer = info[2]
  if (!prdVer) return defaultVersion
  return prdVer
}

export function getMarketChannel() {
  let defaultChannel = 'appshare'
  let ua = navigator.userAgent.toLocaleLowerCase()
  let reg = /\(\/ilisten_(.*)\)/i
  let match = ua.match(reg)
  if (!match) return defaultChannel
  let info = match[1].split('_')
  let channel = info[3]
  if (!channel) return defaultChannel
  return channel
}

export function compareVersion(v1, v2) {
  v1 = v1.split('.')
  v2 = v2.split('.')
  const len = Math.max(v1.length, v2.length)

  while (v1.length < len) {
    v1.push('0')
  }
  while (v2.length < len) {
    v2.push('0')
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i])
    const num2 = parseInt(v2[i])
    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }
  return 0
}

export function getOs() {
  let ua = navigator.userAgent.toLocaleLowerCase()
  let os = 'unknow'
  if (ua.indexOf('like mac os x') !== -1) {
    os = 'ios'
  } else if (ua.indexOf('android') > -1 || ua.indexOf('adr') > -1) {
    os = 'android'
  }
  return os
}

export function isIos() {
  let ua = navigator.userAgent.toLocaleLowerCase()
  return ua.indexOf('like mac os x') !== -1 ? true : false
}

export function isAndroid() {
  let ua = navigator.userAgent.toLocaleLowerCase()
  return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1 ? true : false
}

export function getOsVersion() {
  let ua = navigator.userAgent.toLocaleLowerCase()
  let version = ''
  if (ua.indexOf('like mac os x') !== -1) {
    // ios
    let match = ua.match(/cpu iphone os (.*?) like mac os/)
    if (!match) return ''
    version = match[1].replace(/_/g,'.')
  } else if (ua.indexOf('android') > -1 || ua.indexOf('adr') > -1) {
    // android
    let match = ua.match(/(?:android|adr) (.*?);/i)
    if (!match) return ''
    version = match[1]
  }
  return version
}

/**
 * 是否在口袋故事app内
 * @returns {boolean}
 */
export function isIlisten() {
  let ua = navigator.userAgent.toLocaleLowerCase()
  return ( ua.indexOf('ilisten_ios') !== -1 ) || (ua.indexOf('ilisten_android') !== -1)
}

/**
 * 是否为口袋故事app的iOS版
 * @returns {boolean}
 */
export function isIlistenIos () {
  let ua = navigator.userAgent.toLocaleLowerCase()
  return ua.indexOf('ilisten_ios') !== -1
}

/**
 * 是否为口袋故事app的Android版
 * @returns {boolean}
 */
export function isIlistenAndroid () {
  let ua = navigator.userAgent.toLocaleLowerCase()
  return ua.indexOf('ilisten_android') !== -1
}